import {
  ConfigurationDataType,
  ConfigurationFieldType,
  ConfigurationSectionType,
} from '@ydistri/api-sdk';
import { BaseRootConfiguration } from '../../../../hooks/useCategoryConfiguration';

/**
 * Returns if given ConfigurationFieldType (or ConfigurationDataType) should display entity list select or no
 * @param fieldType
 * @param dataType
 */
export const isEntityListConfiguration = (
  fieldType: ConfigurationFieldType,
  dataType?: ConfigurationDataType,
): boolean =>
  dataType === ConfigurationDataType.SelectBoxMinLayerList ||
  fieldType === ConfigurationFieldType.PsMinLayerList ||
  fieldType === ConfigurationFieldType.PtMinLayerList ||
  fieldType === ConfigurationFieldType.PsSkuScope ||
  fieldType === ConfigurationFieldType.PsSkuScopeForced ||
  fieldType === ConfigurationFieldType.PtSkuScope;

export const isTargetConfiguration = (sectionType: ConfigurationSectionType): boolean =>
  sectionType === ConfigurationSectionType.PotentialTarget;

/**
 * Some "selects" need to have "special select options" inside of them, which will be sent to Calculation Configuration when selected -
 * For example,
 *  - SKU scope on a source has this special option:
 *      - All SKUs
 */
export const specialConfigurationSelectOptions: Partial<
  Record<
    ConfigurationFieldType,
    | {
        /**
         * these will be selectable from select
         */
        selectOptions: ConfigurationFieldType[];

        /**
         * these will always be visible for a given field type (unless they have some requirementsForSpecialConfiguration below)
         */
        additionalConfigurations: ConfigurationFieldType[];
      }
    | undefined
  >
> = {
  [ConfigurationFieldType.PsSkuScope]: {
    selectOptions: [ConfigurationFieldType.PsUseAllSkus],
    additionalConfigurations: [],
  },
  [ConfigurationFieldType.PtSkuScope]: {
    selectOptions: [ConfigurationFieldType.PtUseAllSkus],
    additionalConfigurations: [],
  },
};

/**
 * These are settings that will have highlighted (slightly bigger) font with a gap below => scope settings
 */
export const highlightedConfigurationFieldTypes: Partial<
  Record<ConfigurationFieldType, true | undefined>
> = {
  [ConfigurationFieldType.PsSkuScope]: true,
  [ConfigurationFieldType.PsSkuScopeForced]: true,
  [ConfigurationFieldType.PtSkuScope]: true,
};

export const specialConfigurationsArray: ConfigurationFieldType[] = [];

/**
 * Temporary hiding of obsolete configuration field types from exception overview
 * - category exceptions of these types will get "hidden" flag and will not be displayed
 *    in exception overview or category tree as exceptions
 */
export const hiddenObsoleteConfigurationFieldType = [];

/**
 * Some options have special requirements to be displayed under the select, for example,
 *      - PsUseAdditionalSkus needs to have at least one min layer in PsMinLayerList
 *      - etc...
 * @return true if the fieldType meets the requirements to be displayed, false otherwise for it to be unused
 */
export const checkRequirementsForSpecialConfiguration = (
  /* eslint-disable @typescript-eslint/no-unused-vars -- placeholders */
  fieldType: ConfigurationFieldType,
  rootConfiguration: BaseRootConfiguration | undefined,
  hasRequestList: boolean,
  /* eslint-enable @typescript-eslint/no-unused-vars -- placeholders */
): boolean => {
  return true;
};
